export const cardInventoryControl = {
	cardInfo: {
		stockist: "Estoquista:",
		editedIn: "Editado em:",
		status: "Status:",
		statusTag: {
			approved: "Aprovado",
			open: "Em aberto",
			in_review: "Em revisão",
			reopened: "Recontar",
		},
	},
};
